import videojs from 'video.js';
import utils from './utils.js';
const Component = videojs.getComponent('Component');
const ModalDialog = videojs.getComponent('ModalDialog');

const dom = videojs.dom || videojs;

const DEFAULTS = {};

/**
 * The dialog component for showing moment Settings
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends ModalDialog
 */
class AccessCodeMessage extends ModalDialog {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options); 
		options_.uncloseable = true;
		super(player, options_);
		this.init();
		this.show();
	}

	setListeners_() {
		this.on(this.$('.vjs-access-code-close'), 'click', () => {
			this.hide();
		});

		this.on(this.$('#vjs_access_code_copy'), 'click', () => {
			utils.copyToClipboard(this.$('#vjs_access_code_val'), () => {
				this.$('#vjs_access_code_copy').innerHTML = this.localize("Access code copied");
			});
		});
	}

	init() {
		this.fillWith(this.createContent());
		this.setListeners_();
	}

	show() {
	    super.show();
	    this.$('#vjs_access_code_copy').innerHTML = this.localize("Access code copy");
	}

	hide() {
	    super.hide();
	}

	createContent() {
		return [
			this.createClose_(),
			this.createHeading_(), 
			this.createContent_()
		];
	}

	buildCSSClass() {
		return `vjs-access-code-message ${super.buildCSSClass()}`;
	}
	createClose_() {
		let close = dom.createEl('span', {
			className: 'vjs-access-code-close'
		});
		dom.insertContent(close, '\u00D7');
		return close;
	}

	createHeading_() {
		let heading = dom.createEl('div', {
			className: 'vjs-access-code-caption'
		}, {
			'role': 'heading'
		});
		dom.insertContent(heading, this.localize("Payment successfully completed"));
		return heading;
	}

	createContent_() {
		let content = dom.createEl('div', {
			className: 'vjs-access-code-content'
		});
		dom.appendContent(content,
			[this.createCodeData_(),
			this.createDesc_()]);
		return content;
	}

	createCodeData_() {
		let content = dom.createEl('div', {
			className: 'vjs-access-code-row'
		});

		let txt = dom.createEl('span', {
			className: 'vjs-access-code-txt'
		});
		dom.appendContent(txt, (this.localize("Access code") + ':'));

		let val = dom.createEl('span', {
			id: 'vjs_access_code_val',
			className: 'vjs-access-code-val'
		});
		dom.appendContent(val, this.options_.code);

		let copy = dom.createEl('span', {
			id: 'vjs_access_code_copy',
			className: 'vjs-access-code-copy'
		});

		dom.appendContent(content, [txt, val, copy]);
		return content;
	}

	createDesc_() {
		let desc = dom.createEl('div', {
			className: 'vjs-access-code-desc'
		});
		dom.appendContent(desc, (this.localize("Сode copy to have access to the video")));
		return desc;
	}
}

Component.registerComponent('AccessCodeMessage', AccessCodeMessage);
export default AccessCodeMessage;